var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.showLoading ? _c('div', [_c('Loading')], 1) : _vm._e(), _vm.isList ? [_c('swiper', {
    attrs: {
      "space-between": 50,
      "options": _vm.swiperOption
    }
  }, _vm._l(_vm.groupBuyings, function (groupBuying) {
    return _c('swiper-slide', {
      key: groupBuying.id
    }, [_c('ProductCard', {
      attrs: {
        "isLoading": _vm.showLoading,
        "groupBuying": groupBuying
      },
      on: {
        "chooseGroupBuying": _vm.chooseGroupBuying
      }
    })], 1);
  }), 1), _c('div', {
    staticClass: "swiper-button-prev"
  }), _c('div', {
    staticClass: "swiper-button-next"
  })] : [_vm.groupBuyings[0] ? _c('ProductCard', {
    attrs: {
      "groupBuying": _vm.groupBuyings[0]
    },
    on: {
      "chooseGroupBuying": _vm.chooseGroupBuying
    }
  }) : _vm._e()], _vm.groupBuyings.length == 0 && _vm.isLoaded ? _c('div', {
    staticClass: "empty-list"
  }, [_c('svg', {
    attrs: {
      "width": "200",
      "height": "100",
      "viewBox": "0 0 200 100",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M92.7059 17V39.9412H43V82H157.706V55.2353H150.059V17H92.7059ZM94.6176 18.9118H106.088V38.7198L113.735 34.351L121.382 38.7198V18.9118H132.853V55.2353H94.6176V18.9118ZM108 18.9118H119.471V35.4272L113.735 32.149L108 35.4272V18.9118ZM134.765 18.9118H148.147V55.2353H134.765V18.9118ZM44.9118 41.8529H56.3824V59.7492L64.0294 55.3804L71.6765 59.7492V41.8529H83.1471V80.0882H44.9118V41.8529ZM58.2941 41.8529H69.7647V56.4566L64.0294 53.1785L58.2941 56.4566V41.8529ZM85.0588 41.8529H92.7059V55.2353H85.0588V41.8529ZM85.0588 57.1471H107.043V80.0882H85.0588V57.1471ZM108.957 57.1471H116.604V80.0882H108.957V57.1471ZM118.516 57.1471H140.5V80.0882H118.516V57.1471ZM142.414 57.1471H155.796V80.0882H142.414V57.1471Z",
      "fill": "#C0C4CC"
    }
  })]), _c('div', [_vm._v("沒有團購商品")])]) : _vm._e(), _c('Popup', {
    ref: "popupChooseGroupBuying",
    attrs: {
      "title": "確認下單"
    }
  }, [_vm.chosenGroupBuying.need_choose_branch ? [_c('div', {
    staticClass: "s-space-x-2 s-flex mb-2"
  }, [_c('SharedSelect', {
    attrs: {
      "value": _vm.city,
      "options": _vm.cityOptions,
      "placeholder": "請選擇縣市"
    },
    on: {
      "input": _vm.handleCityChange
    }
  }), _c('SharedSelect', {
    attrs: {
      "value": _vm.district,
      "options": _vm.districtOptions,
      "placeholder": "請選擇區"
    },
    on: {
      "input": _vm.handleDistrictChange
    }
  })], 1), _c('div', {
    staticClass: "s-mb-5"
  }, [_c('SharedSelect', {
    attrs: {
      "options": _vm.branchOptions,
      "placeholder": "請選擇分店"
    },
    model: {
      value: _vm.branch,
      callback: function callback($$v) {
        _vm.branch = $$v;
      },
      expression: "branch"
    }
  })], 1)] : _vm._e(), _c('div', {
    staticClass: "s-mt-5 s-mb-5 s-text-left"
  }, [_vm._v(" " + _vm._s(_vm.chosenGroupBuying.order_message) + " ")]), _c('div', {
    staticClass: "s-flex s-space-x-2",
    attrs: {
      "slot": "actions"
    },
    slot: "actions"
  }, [_c('button', {
    staticClass: "s-btn s-liff-theme-btn-outline s-btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.$refs.popupChooseGroupBuying.close();
      }
    }
  }, [_vm._v(" 取消 ")]), _c('button', {
    staticClass: "s-btn s-liff-theme-btn s-btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.handleChoosegroupBuyingstore
    }
  }, [_vm._v(" " + _vm._s(_vm.showLoading ? '處理中...' : '確定加入') + " ")])])], 2), _c('Popup', {
    ref: "popupJoinSuccess",
    attrs: {
      "title": "下單完成"
    }
  }, [_c('div', {
    staticClass: "s-mt-5 s-mb-5"
  }, [_vm._v(" " + _vm._s(_vm.chosenGroupBuying.success_message) + " ")]), _c('div', {
    staticClass: "s-flex s-space-x-2",
    attrs: {
      "slot": "actions"
    },
    slot: "actions"
  }, [_c('button', {
    staticClass: "s-btn s-btn-outline-primary s-btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.goOrderList
    }
  }, [_vm._v(" 團購紀錄 ")]), _c('button', {
    staticClass: "s-btn s-btn-outline-primary s-btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.goCoreGroupbuyingList
    }
  }, [_vm._v(" 回團購商品頁 ")])])])], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }